import script from "./PipelineHygiene.vue?vue&type=script&setup=true&lang=js"
export * from "./PipelineHygiene.vue?vue&type=script&setup=true&lang=js"

import "./PipelineHygiene.vue?vue&type=style&index=0&id=23a0a4ce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a0a4ce"]])

export default __exports__